export const DOC_TYPE_LABEL = {
  CPF_DOCUMENT: "Documento (frente)",
  CPF_DOCUMENT_BACK: "Documento (verso)",
  RG: "RG",
  CNH: "CNH",
  PROOF_OF_RESIDENCE: "Comprovante de residência",
  PROOF_OF_INCOME: "Comprovante de renda",
  CNPJ_CARD: "Cartão CNPJ",
  SOCIAL_CONTRACT: "Contrato social / MEI",
  SELFIE: "Selfie com documento",
  BANK_STATEMENT: "Extrato bancário",
  OTHER: "Foto da atividade",
};

export const REQUIRED_REVIEW_DOCUMENT_TYPES = ["CPF_DOCUMENT", "SELFIE", "OTHER"];

export const UPLOAD_ACCEPTED_MIME_TYPES = ["image/jpeg", "image/png", "image/webp", "application/pdf"];

export const UPLOAD_MAX_BYTES = 20 * 1024 * 1024;

export function getDocumentTypeLabel(documentType) {
  return DOC_TYPE_LABEL[documentType] || documentType;
}

export function describeDocumentTypes(documentTypes) {
  return (documentTypes || []).map(getDocumentTypeLabel).join(", ");
}

export function getMissingRequiredReviewDocuments(documents) {
  const presentTypes = new Set((documents || []).map((doc) => doc.documentType));
  return REQUIRED_REVIEW_DOCUMENT_TYPES.filter((documentType) => !presentTypes.has(documentType));
}
